module.exports = __webpack_public_path__ + "r-v3/img/interpreter_white.1ccbbd91.svg";